import * as mutationTypes from "../../mutation-types";

const state = {
	persistedData: {
		configurationStep: 0
	}
};

const getters = {
	configurationStep: state => state.persistedData.configurationStep
};

const mutations = {
	[mutationTypes.UPDATE_CONFIGURATION_STEP] (state, {direction}) {
		state.persistedData.configurationStep = direction === "next"
			? state.persistedData.configurationStep + 1
			: state.persistedData.configurationStep - 1;
	},
	[mutationTypes.INCREASE_CONFIGURATION_STEP] (state) {
		state.persistedData.configurationStep++;
	},
	[mutationTypes.DECREASE_CONFIGURATION_STEP] (state) {
		state.persistedData.configurationStep--;
	},
	[mutationTypes.RESET_CONFIGURATION_STEP] (state, {resetValue}) {
		state.persistedData.configurationStep = resetValue;
	}
};

export default {
	state,
	getters,
	mutations
};
